/* GlowBiome Serum LP — GSAP / ScrollTrigger motion
   Loaded only after gsap.min.js + ScrollTrigger.min.js.
   This is the directable layer: tweak per-section effects here. */
(function () {
  if (!window.gsap || !window.ScrollTrigger) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  gsap.registerPlugin(ScrollTrigger);
  var EASE = 'power3.out';

  /* 1) Reveal — single elements fade/slide up as they enter ---------------- */
  var single = [
    '.problem .eyebrow', '.problem h2', '.problem .lead',
    '.solution .eyebrow',
    '.neroli .eyebrow', '.neroli h2', '.neroli .sub',
    '.texture__body',
    '.howto .head', '.howto .foot',
    '.rec .head',
    '.faq .head', '.acc',
    '.finalcta .head'
  ].join(',');
  gsap.utils.toArray(single).forEach(function (el) {
    gsap.from(el, { opacity: 0, y: 28, duration: 0.9, ease: EASE,
      scrollTrigger: { trigger: el, start: 'top 88%' } });
  });

  /* 2) Staggered groups ---------------------------------------------------- */
  gsap.utils.toArray('.cards, .steps, .rec-grid, .tlist').forEach(function (g) {
    gsap.from(g.children, { opacity: 0, y: 32, duration: 0.8, ease: EASE, stagger: 0.09,
      scrollTrigger: { trigger: g, start: 'top 85%' } });
  });

  /* 3) Hero — full-screen image: brightness/scale intro, slow zoom + crossfade */
  gsap.from('.hero__head', { opacity: 0, y: 22, duration: 1.2, ease: EASE, delay: 0.15 });
  (function () {
    var A = document.querySelector('.scene__img--a');
    var B = document.querySelector('.scene__img--b');
    if (!A || !B) return;
    var H = 8, F = 1.8, Z = 1.05;   /* each image shows ~H s, F crossfade, starts at scale Z and only shrinks to 1 */
    gsap.set(A, { opacity: 1, scale: Z });
    gsap.set(B, { opacity: 0, scale: Z });
    gsap.timeline({ repeat: -1 })
      .fromTo(A, { scale: Z }, { scale: 1, duration: H - F, ease: 'none' }, 0)
      .to(A, { opacity: 0, duration: F, ease: 'power1.inOut' }, H - F)
      .to(B, { opacity: 1, duration: F, ease: 'power1.inOut' }, H - F)
      .set(A, { scale: Z }, H)
      .fromTo(B, { scale: Z }, { scale: 1, duration: H - F, ease: 'none' }, H)
      .to(B, { opacity: 0, duration: F, ease: 'power1.inOut' }, 2 * H - F)
      .to(A, { opacity: 1, duration: F, ease: 'power1.inOut' }, 2 * H - F)
      .set(B, { scale: Z }, 2 * H);
  })();
  /* headline fades out as you scroll into the scene */
  gsap.to('.scene__hero', { opacity: 0, ease: 'none',
    scrollTrigger: { trigger: '.scene', start: 'top top', end: '+=22%', scrub: true } });

  /* 4) Scene — frosted veil fades in, then darkens by the Solution --------- */
  /* brief sharp beat to admire the full photo, then frost snaps in */
  gsap.fromTo('.scene__veil', { opacity: 0 }, { opacity: 1, ease: 'power1.in',
    scrollTrigger: { trigger: '.scene', start: 'top -25%', end: '+=32%', scrub: true } });
  gsap.fromTo('.scene__dark', { opacity: 0 }, { opacity: 1, ease: 'none',
    scrollTrigger: { trigger: '.solution', start: 'top 85%', end: 'top 28%', scrub: true } });

  gsap.from('#buy .bb-card', { opacity: 0, y: 26, duration: 1, ease: EASE,
    scrollTrigger: { trigger: '#buy', start: 'top 80%' } });

  /* 5) Solution copy — per-character opacity reveal on scroll -------------- */
  var stmt = document.querySelector('.solution .statement');
  if (stmt) {
    var chars = splitChars(stmt);
    gsap.set(chars, { opacity: 0.18 });
    gsap.to(chars, { opacity: 1, ease: 'none', stagger: 0.5,
      scrollTrigger: { trigger: '.solution', start: 'top 88%', end: 'center 68%', scrub: true } });
  }

  /* 6) Parallax — texture image drifts ------------------------------------ */
  gsap.utils.toArray('.texture__media').forEach(function (media) {
    var inner = media.querySelector('img, .placeholder') || media;
    gsap.set(inner, { scale: 1.12 });
    gsap.fromTo(inner, { yPercent: -6 }, { yPercent: 6, ease: 'none',
      scrollTrigger: { trigger: media, start: 'top bottom', end: 'bottom top', scrub: true } });
  });

  /* 7) Key Ingredients — pinned card sequence (desktop only) --------------- */
  var mm = gsap.matchMedia();
  mm.add('(min-width: 901px)', function () {
    /* run the pinned card sequence independently for EACH .ki (serum + mask) */
    var seqKis = [];
    gsap.utils.toArray('.ki').forEach(function (ki) {
      var cards = gsap.utils.toArray(ki.querySelectorAll('.ki-card'));
      if (!cards.length) return;
      ki.classList.add('is-seq');
      seqKis.push(ki);
      /* first card centered; the rest wait below, ready to rise up */
      gsap.set(cards, { yPercent: 90, opacity: 0 });
      gsap.set(cards[0], { yPercent: 0, opacity: 1 });
      var HOLD = 0.7;
      var tl = gsap.timeline({
        scrollTrigger: { trigger: ki, start: 'top top',
          end: '+=' + (cards.length * 720), pin: true, scrub: true, anticipatePin: 1 }
      });
      tl.to({}, { duration: HOLD });
      for (var i = 1; i < cards.length; i++) {
        /* previous card pushes up and fades out */
        tl.to(cards[i - 1], { yPercent: -85, opacity: 0, scale: 0.94, duration: 0.6, ease: 'power1.in' });
        /* new card rises from below into the center */
        tl.fromTo(cards[i], { yPercent: 90, opacity: 0 },
          { yPercent: 0, opacity: 1, duration: 0.6, ease: 'power2.out' }, '<');
        tl.to({}, { duration: HOLD });
      }
    });
    return function () {
      seqKis.forEach(function (ki) { ki.classList.remove('is-seq'); });
      gsap.utils.toArray('.ki-card').forEach(function (c) { gsap.set(c, { clearProps: 'all' }); });
    };
  });

  /* 8) Final CTA pop ------------------------------------------------------- */
  gsap.from('.finalcta .bb-card', { opacity: 0, y: 36, scale: 0.97, duration: 1, ease: EASE,
    scrollTrigger: { trigger: '.finalcta', start: 'top 70%' } });

  ScrollTrigger.refresh();

  /* split a node's text into per-character spans, preserving child elements (e.g. <em>) */
  function splitChars(root) {
    var out = [];
    Array.prototype.slice.call(root.childNodes).forEach(function (node) {
      if (node.nodeType === 3) {
        var frag = document.createDocumentFragment();
        node.textContent.split('').forEach(function (c) {
          if (c === ' ') { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'ch';
          s.style.display = 'inline-block';
          s.textContent = c;
          frag.appendChild(s);
          out.push(s);
        });
        root.replaceChild(frag, node);
      } else if (node.nodeType === 1) {
        out = out.concat(splitChars(node));
      }
    });
    return out;
  }
})();
